import {
  fcmTokenConverter,
  getFcmTokenDoc as _getFcmTokenDoc,
} from '@griply/services';
import { FcmToken } from '@griply/types';
import {
  doc,
  DocumentReference,
  FirestoreDataConverter,
  getFirestore,
} from 'firebase/firestore';

// Firebase's FirestoreDataConverter is invariant on the snapshot type; the
// shared converter uses a structural DocumentSnapshot, so cast at the call
// site rather than rewrapping. Same shape, just narrower nominal typing.
const converter =
  fcmTokenConverter as unknown as FirestoreDataConverter<FcmToken>;

export const getFcmTokenDoc = (token: string) =>
  _getFcmTokenDoc<DocumentReference, ReturnType<typeof getFirestore>>({
    token,
    db: getFirestore(),
    doc,
  }).withConverter(converter);
